/* No libraries, no scroll hijacking, no order or payment operations. */
(() => {
  if (window.__blueBasculeLoaded) return;
  window.__blueBasculeLoaded = true;
  const initialized = new WeakSet();
  const mediaMobile = window.matchMedia('(max-width: 900px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const focusables = el => [...el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),summary,[tabindex="0"]')].filter(x => x.getClientRects().length);
  const normalizeBuyButtons = product => {
    const title = product.querySelector('h1')?.textContent.trim();
    product.querySelectorAll('img[alt="Thumbnail"], img[data-bo-thumbnail]').forEach((img,i) => { if (title && product.dataset.boThumbnailLabel) { img.dataset.boThumbnail = true; img.alt = `${title} — ${product.dataset.boThumbnailLabel} ${i + 1}`; } });
    const addLabel = product.dataset.boAddLabel;
    if (!addLabel) return;
    product.querySelectorAll('button[type="submit"],input[type="submit"]').forEach(button => {
      const label = (button.value || button.textContent || '').trim().toLocaleLowerCase('fr');
      if (label === "options d'affichage" || label === 'options d’affichage') {
        if ('value' in button && button.tagName === 'INPUT') button.value = addLabel;
        else button.textContent = addLabel;
        button.setAttribute('aria-label', addLabel);
      }
    });
  };
  function init(scope = document) {
    scope.querySelectorAll('[data-bb-header]').forEach(header => {
      if (initialized.has(header)) return;
      initialized.add(header);
      const menu = header.querySelector('[data-bb-menu]');
      const summary = menu?.querySelector('summary');
      const drawer = menu?.querySelector('[data-bb-drawer]');
      const main = document.getElementById('content');
      let oldOverflow = '', oldInert = false, locked = false;
      function setOpenState() {
        if (!menu || !drawer) return;
        const open = menu.open;
        header.classList.toggle('menu-open', open);
        summary.setAttribute('aria-expanded', String(open));
        if (open && !locked) {
          locked = true;
          oldOverflow = document.body.style.overflow;
          oldInert = main?.inert || false;
          document.body.style.overflow = 'hidden';
          if (main) main.inert = true;
          drawer.setAttribute('role', 'dialog');
          drawer.setAttribute('aria-modal', 'true');
          (drawer.querySelector('nav a[href]') || summary).focus();
        } else if (!open && locked) {
          locked = false;
          document.body.style.overflow = oldOverflow;
          if (main) main.inert = oldInert;
          drawer.removeAttribute('role'); drawer.removeAttribute('aria-modal');
          summary.focus({preventScroll:true});
        }
      }
      menu?.addEventListener('toggle', setOpenState);
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          if (menu?.open) { menu.open = false; setOpenState(); event.preventDefault(); event.stopPropagation(); }
          header.querySelectorAll('[data-bb-dropdown][open]').forEach(d => {d.open=false; d.querySelector('summary').focus();});
        }
        if (event.key === 'Tab' && locked) {
          const elements = [summary, ...focusables(drawer)];
          const first=elements[0], last=elements[elements.length-1];
          if (event.shiftKey && document.activeElement === first) {last.focus();event.preventDefault();}
          else if (!event.shiftKey && document.activeElement === last) {first.focus();event.preventDefault();}
        }
      });
      drawer?.addEventListener('click',event=>{if(event.target.closest('a[href]')){menu.open=false;setOpenState();}});
      document.addEventListener('click',e=>header.querySelectorAll('[data-bb-dropdown][open]').forEach(d=>{if(!d.contains(e.target))d.open=false;}));
      const hero=document.querySelector('[data-bb-hero]');
      if(hero){
        const sync=()=>header.classList.toggle('is-solid',hero.getBoundingClientRect().bottom<=header.offsetHeight);
        window.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync);sync();
      }else header.classList.add('is-solid');
      header.addEventListener('shopify:section:unload',()=>{if(locked){menu.open=false;setOpenState();}});
    });
    scope.querySelectorAll('[data-bb-hero]').forEach(hero=>{
      if(initialized.has(hero))return;initialized.add(hero);
      const video=hero.querySelector('video'),control=hero.querySelector('[data-bb-video-control]');
      if(!video||!control)return;
      const url=mediaMobile.matches?(video.dataset.mobile||video.dataset.desktop):(video.dataset.desktop||video.dataset.mobile);
      if(!url)return;
      const key='bo-bascule-seen:'+url;
      let seen=false,playing=false;try{seen=sessionStorage.getItem(key)==='1';}catch(_e){}
      const mark=()=>{try{sessionStorage.setItem(key,'1');}catch(_e){}};
      async function play(){
        try{
          if(!video.getAttribute('src'))video.src=url;
          video.muted=true;
          if(video.ended)video.currentTime=0;
          await video.play();playing=true;video.classList.add('is-playing');control.textContent=control.dataset.pause;control.setAttribute('aria-label',control.dataset.pauseLabel);mark();
        }catch(_e){playing=false;video.classList.remove('is-playing');control.textContent=control.dataset.start;control.setAttribute('aria-label',control.dataset.startLabel);}
      }
      control.hidden=false;control.textContent=control.dataset.start;
      control.addEventListener('click',()=>{if(playing){video.pause();}else play();});
      video.addEventListener('pause',()=>{playing=false;control.textContent=video.ended?control.dataset.replay:control.dataset.resume;control.setAttribute('aria-label',control.textContent);});
      video.addEventListener('ended',()=>{playing=false;control.textContent=control.dataset.replay;control.setAttribute('aria-label',control.textContent);});
      video.addEventListener('error',()=>{video.classList.remove('is-playing');control.hidden=true;});
      const stopWhenReduced=()=>{if(reduced.matches){video.pause();video.classList.remove('is-playing');}};reduced.addEventListener('change',stopWhenReduced);
      document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();});
      if(!seen&&!reduced.matches&&!navigator.connection?.saveData&&!document.documentElement.classList.contains('theme-editor'))play();
    });
    scope.querySelectorAll('.bb-founders, .bb-universes, .bo-collection').forEach(gallery=>{
      if(initialized.has(gallery))return;initialized.add(gallery);
      let touchLink=null;
      gallery.addEventListener('pointerdown',event=>{
        touchLink=event.pointerType==='touch'?event.target.closest('.bb-art,.bb-universe,.bo-product-card__link'):null;
      });
      gallery.addEventListener('click',event=>{
        const link=event.target.closest('.bb-art,.bb-universe,.bo-product-card__link');
        if(!link||!gallery.contains(link))return;
        const isTouch=touchLink===link||window.matchMedia('(hover:none)').matches;
        touchLink=null;
        if(!isTouch||!link.querySelector('.bb-art__image--secondary,.bb-universe__image--secondary,.bo-product-card__image--secondary'))return;
        const previewClass=link.matches('.bo-product-card__link')?'bo-product-card--touch-preview':'bb-card--touch-preview';
        if(!link.classList.contains(previewClass)){
          event.preventDefault();
          document.querySelectorAll('.bb-card--touch-preview,.bo-product-card--touch-preview').forEach(item=>{if(item!==link)item.classList.remove('bb-card--touch-preview','bo-product-card--touch-preview');});
          link.classList.add(previewClass);
        }
      });
    });
    scope.querySelectorAll('#main-product').forEach(product=>{
      if(initialized.has(product)){normalizeBuyButtons(product);return;}initialized.add(product);
      product.querySelectorAll('header h1').forEach(title=>{
        const shortTitle=title.textContent.split(' — ')[0].trim();
        if(shortTitle)title.textContent=shortTitle;
      });
      normalizeBuyButtons(product);
      new MutationObserver(()=>normalizeBuyButtons(product)).observe(product,{childList:true,subtree:true,characterData:true});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',()=>init());
})();

